export default "__VITE_ASSET__I12u$XqM__"